export const isTestingOrInternalEmailDomain = domain => {
  return ['hubspot.com', 'hubspotemail.net', 'hubspotemailqa.com'].includes(domain);
};